import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import weui from "weui.js";
import defaultHead from "../../assets/image/default-head.png";
import {
  Cell,
  CellBody,
  CellButton,
  CellHeader,
  Cells,
  CellsTips,
  Input,
  Label,
  MediaBoxAppMsg,
  Panel,
  PanelBody
} from "../../components/weui";
import { userService } from "../../services";
import { refreshUser, selectUser } from "../../stores";
import { urls } from "../../urls";
import { getAxiosError } from "../../utils";

export const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const defaultPhone = user?.phone ?? "";
  const defaultPass = user?.pass ?? "";
  const [phone, setPhone] = useState(defaultPhone);
  const [pass, setPass] = useState(defaultPass);
  const [isPassChanged, setIsPassChanged] = useState(false);
  const canSave = useMemo(() => phone !== defaultPhone || pass !== defaultPass, [phone, pass, defaultPhone, defaultPass]);

  useEffect(() => {
    setPhone(user?.phone);
    setPass(user?.pass);
  }, [user, setPhone, setPass]);

  const handleSave = useCallback(async e => {
    if (phone.length !== 11 || !phone.startsWith("1")) {
      weui.topTips("请输入有效的手机号");
      return;
    }

    if (isPassChanged && pass.length < 6) {
      weui.topTips("登陆密码长度不得小于 6 位");
      return;
    }

    const loading = weui.loading("保存中...");
    try {
      await userService.updatePhone(phone, pass);
      await dispatch(refreshUser());
      setIsPassChanged(false);
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      loading.hide();
    }
  }, [phone, pass, dispatch, isPassChanged, setIsPassChanged]);

  // 输入时清空旧密码
  const handlePwdKeyDown = useCallback(e => {
    if (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || e.key === "Tab") return;

    if (!isPassChanged && e.target.value === defaultPass) {
      setPass("");
      setIsPassChanged(true);
    }
  }, [setPass, defaultPass, isPassChanged, setIsPassChanged]);

  const handleIconClick = useCallback(e => {
    if (e.detail === 3) {
      navigate(urls.bindEBMS());
    }
  }, [navigate]);

  return (
    <>
      <Panel>
        <PanelBody onClick={ handleIconClick }>
          <MediaBoxAppMsg icon={ user?.pic || defaultHead } title={ user?.name } desc="" />
        </PanelBody>
      </Panel>
      <Cells>
        <Cell>
          <CellHeader>
            <Label htmlFor="elPhone">手机号</Label>
          </CellHeader>
          <CellBody>
            <Input id="elPhone"
              placeholder="请输入您的手机号码"
              type="number"
              value={ phone }
              onChange={ e => setPhone(e.target.value) } />
          </CellBody>
        </Cell>
        <Cell>
          <CellHeader>
            <Label htmlFor="elPwd">登陆密码</Label>
          </CellHeader>
          <CellBody>
            <Input id="elPwd"
              placeholder="请输入您的登陆密码"
              type="password"
              value={ pass }
              onChange={ e => setPass(e.target.value) }
              onKeyDown = { handlePwdKeyDown }
            />
          </CellBody>
        </Cell>
      </Cells>

      <CellsTips>如果您需要使用[支付宝]或[企业网银]进行付款操作, 请在此处设置您的手机号及登陆密码, 之后即可使用手机号和密码在手机自带浏览器中登陆本系统, 并发起[支付宝]或[企业网银]付款操作.</CellsTips>

      <Cells>
        <CellButton type="primary" onClick={ handleSave }
          disabled={ !canSave }>保存</CellButton>
      </Cells>
    </>
  );
};
